import { createReducer } from "@reduxjs/toolkit";
import type { UpdateState } from "@redux/state/shared-types";
import { resetUpdateStudentSettings, updateStudentSettings } from "./update-student-settings";

const initialState: UpdateState = { justUpdatedId: null, processing: "idle" };

export const updateStudentSettingsReducer = createReducer<UpdateState>(initialState, builder => {
  builder.addCase(updateStudentSettings.fulfilled, (state, { payload }) => {
    return {
      ...state,
      justUpdatedId: payload,
      processing: "success",
    };
  });
  builder.addCase(updateStudentSettings.pending, state => {
    return {
      ...state,
      processing: "pending",
    };
  });
  builder.addCase(updateStudentSettings.rejected, state => {
    return {
      ...state,
      processing: "failed",
    };
  });
  builder.addCase(resetUpdateStudentSettings, () => {
    return initialState;
  });
});
